<template>
  <DpplSkeletonLoader class="horizontal-bar-skeleton">
    <div class="skeleton-body">
      <div
        v-for="(barWidth, index) in barsWidths"
        :key="index"
        class="chart-bars"
      >
        <div
          :style="{ width: `${barWidth}px` }"
          class="bar mt-4"
        />
      </div>
      <div class="benchmark" />
    </div>
  </DpplSkeletonLoader>
</template>

<script>
import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';

export default {
  name: 'HorizontalBarChartWidgetSkeleton',
  components: {
    DpplSkeletonLoader,
  },
  data() {
    return {
      barsWidths: [320],
    };
  },
};
</script>

<style lang="less" scoped>
.horizontal-bar-skeleton {
  height: 100%;
  width: 100%;
}

.skeleton-body {
  height: calc(100% - 17px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 24px;
}

.chart-bars {
  display: flex;
  align-items: center;
}

.bar {
  background-color: @grey-400;
  height: 24px;
  margin-left: 24px;
  z-index: 2;
}

.benchmark {
  margin-left: 150px;
  width: 45px;
  min-height: 70px;
  background: linear-gradient(@skeleton, @white);
  transform: translateY(-65%);
}
</style>
